export const appointmentTimeWithTimeOffset = (
  date: string,
  timeZone: string
) => {
  const appointmentDate = new Date(Number(date));
  const localTime = new Date(
    appointmentDate.getTime() - Number(timeZone) * 1000 * 60 * 60
  );
  return localTime;
};
